module.exports = __webpack_public_path__ + "static/2_3_game-tree-3_EL-dd7d1ce016aa3466fb8dce20d5020f37.svg";